<template>
  <div class="select">
    <img slot="icon" :src="reviewMap" @click="handleReviewImage" class="reviewMap icon" />
    <input readonly type="text" :value="selectValue" :placeholder="placeholder" class="input" @click="visible = true" />
    <Popup v-model="visible" position="bottom">
      <Picker show-toolbar value-key="text" :columns="columns" @cancel="visible = false" @confirm="onChange" />
    </Popup>
  </div>
</template>

<script>
import { Picker, Popup, ImagePreview } from 'vant';
import reviewMap from '@/assets/icon/reviewMap.svg';

export default {
  props: ['value', 'placeholder', 'columns', 'src'],
  components: { Picker, Popup },
  data() {
    return {
      reviewMap,
      visible: false,
      selectValue: '',
      isReviewMap: false,
      images: [`${window.location.origin}/img/picture/map.png`],
    };
  },
  methods: {
    onChange(value) {
      const val = value.id;
      this.$emit('update:value', val, value);
      this.visible = false;
    },

    handleReviewImage() {
      ImagePreview({
        images: this.images, // 预览图片的那个数组
        showIndex: false,
        loop: false,
        // closeIcon: `${window.location.origin}/img/picture/close.png`,
        startPosition: 0,
        // closeIconPosition: 'bottom',
      });
    },
  },

  mounted() {},
  watch: {
    value(val) {
      if (val && !!this.columns.length) {
        const newValue = this.columns.filter(i => i.id === val);
        this.selectValue = newValue[0].text;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.select {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

img {
  &.reviewMap {
    width: 38px;
    margin-right: 20px;
  }
}
.input {
  border: none;
  font-size: 30px;
  padding: 6px 0;
  line-height: 34px;
  color: #3d424d;
  width: 100%;

  &::placeholder {
    color: #949aa4;
  }
}
</style>
